import {
  OnboardingFormPayload,
  PressureTypeFull,
  STATION_USAGE_TYPES,
  TIER_VALUES,
} from '@/store/SiteSurveyForm/constants';
import { FormInstance } from 'antd';
import SiteSurveyStore from '@/store/SiteSurveyForm/SiteSurveyStore';

export const getStationPressureName = (pressureType: PressureTypeFull): string => {
  if (pressureType === PressureTypeFull.HIGH) {
    return 'HP';
  }
  if (pressureType === PressureTypeFull.LOW) {
    return 'LP';
  }
  if (pressureType === PressureTypeFull.MEDIUM) {
    return 'MP';
  }
  return 'Main';
};

export const getFormDisplayName = (form: OnboardingFormPayload): string => {
  const state = form?.siteData?.generalData?.siteAddress?.state;
  const country = form?.siteData?.generalData?.siteAddress?.country;
  const locationInfo: string =
    state?.length > 0
      ? `${form?.siteData?.generalData?.siteAddress?.state?.[0]}${
          state.length >= 2 ? form?.siteData?.generalData?.siteAddress?.state?.[1] : ''
        }`
      : `${country}`;

  const siteName = `${form?.siteData?.generalData?.siteAddress?.city} ${locationInfo}`;

  const stationNameSuffix = form?.siteData?.siteGeneralConfiguration?.stationNameSuffix;

  const tier = form?.siteData?.generalData?.stationTier;
  const usageType = form?.siteData?.generalData?.stationUsageType;
  const fallbackSuffix =
    tier === TIER_VALUES.MONITOR && usageType === STATION_USAGE_TYPES.INTERNAL
      ? STATION_USAGE_TYPES.INTERNAL
      : getStationPressureName(form?.siteData?.siteGeneralConfiguration?.pressureType);

  return `${siteName} | ${stationNameSuffix ?? fallbackSuffix}`;
};

export interface RegionOption {
  key: string;
  label: string;
  originalRegions: string[];
}

export const REGION_KEYS = {
  AMERICAS: 'AMERICAS',
  EMEIA: 'EMEIA',
  APAC: 'APAC',
} as const;

export const ORIGINAL_REGIONS = {
  NORTH_AMERICA: 'north-america',
  LATAM: 'latam',
  EMEIA: 'emeia',
  APAC: 'apac',
} as const;

export const getAvailableRegions = (userRegions: string[]): RegionOption[] => {
  const regionMapping: RegionOption[] = [
    {
      key: REGION_KEYS.AMERICAS,
      label: REGION_KEYS.AMERICAS,
      originalRegions: [ORIGINAL_REGIONS.NORTH_AMERICA, ORIGINAL_REGIONS.LATAM],
    },
    {
      key: REGION_KEYS.EMEIA,
      label: REGION_KEYS.EMEIA,
      originalRegions: [ORIGINAL_REGIONS.EMEIA],
    },
    {
      key: REGION_KEYS.APAC,
      label: REGION_KEYS.APAC,
      originalRegions: [ORIGINAL_REGIONS.APAC],
    },
  ];

  return regionMapping.filter(region =>
    region.originalRegions.some(originalRegion => userRegions.includes(originalRegion)),
  );
};

export const createHandleRegionChange = (siteSurveyStore: SiteSurveyStore, form?: FormInstance) => {
  return (value: string) => {
    siteSurveyStore.setSelectedRegion(value);
    if (form) {
      form.setFieldValue('region', value);
    }
  };
};
